/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.style.constants

const val UNSET = "unset"
const val AUTO = "auto"
const val POINTER = "pointer"
const val INITIAL = "initial"
const val NONE = "none"
const val INHERIT = "inherit"
const val HIDDEN = "hidden"
const val INSIDE = "inside"

const val LARGE = "large"
const val LARGER = "larger"
const val SMALLER = "smaller"
const val FIT_CONTENT = "fit-content"
const val MIN_CONTENT = "min-content"

const val USER_SELECT = "user-select"

const val MOZ_FIT_CONTENT = "-moz-fit-content"
const val MOZ_USER_SELECT = "-moz-user-select"

const val MS_USER_SELECT = "-ms-user-select"
const val MS_OVERFLOW_STYLE = "-ms-overflow-style"

const val WEBKIT_FILL_AVAILABLE = "-webkit-fill-available"
const val WEBKIT_USER_SELECT = "-webkit-user-select"
